import React, {Component} from 'react';
import {observer, inject} from 'mobx-react';
import {Link} from 'react-router-dom';
import intl from 'react-intl-universal';

import Button from "../../../../components/Button";

import DrawerButton from "../DrawerButton";
import LayerToggle from "../LayerToggle";
import DrawerContainer from "../DrawerContainer";
import MapButtons from "../MapButtons";

import './BottomContainerMobile.css';
import {formatElementsforExport, postData} from "../../../../utils/Utils";

@inject("appStore")
@observer
class BottomContainerMobile extends Component {
    saveMapData = () => {
        let data = {
            responseId: this.props.appStore.responseID,
            branchId: this.props.appStore.appConfig.branchId,
            tableName: (this.props.appStore.environment === 'staging') ? "mycampus_elems_test" : 'mycampus_elems',
            mapData: {
                elements: []
            }
        };

        data.mapData.elements = formatElementsforExport(this.props.appStore.elementStore.elements);

        let productionURL = 'https://23tkwzjvr2.execute-api.us-east-1.amazonaws.com/myc_postdata_s3_lambda/MYC-S3-Lambda';
        let stagingURL = 'https://dj3mppbaa4.execute-api.us-east-1.amazonaws.com/myc_postdata_s3_lambda_staging/MYC-S3-Lambda_STAGING';

        postData((this.props.appStore.environment === 'production') ? productionURL : stagingURL, JSON.stringify(data), (response) => {
            console.log(this.props.appStore.environment, response);
            if (response.ok) {
                window.location = 'https://www.surveygizmo.com/s3/4699627/SU-Whitman-MyBuilding-Survey?responseID=' + this.props.appStore.responseID;
            } else {
                window.location = 'http://comap.sasaki.com/wlee/#/error';
            }
        });
    };

    render() {
        let questionTypes = Object.keys(this.props.appStore.questionStore.questions);
        return (
            <div className="BottomContainerMobile">
                <MapButtons/>
                {/*<LayerToggle map={this.props.appStore.map}
                             mode={this.props.appStore.map.mode}
                             center={this.props.appStore.map.viewport.center}
                             layers={this.props.appStore.appConfig.map.layerIds} />*/}

                {!this.props.appStore.pendingState.savePopup && !this.props.appStore.pendingState.confirmationPopup &&
                <div className="bottomContainer">
                    <div className="drawerButtons">
                        {questionTypes.map((type, index) =>
                            <DrawerButton key={type}
                                          questionType={type}>
                                {type}
                            </DrawerButton>
                        )}
                    </div>
                    {/*<Link
                        to={`/survey`}>
                        <Button className={'finishedButton ' + (this.props.appStore.drawer.open ? 'drawer-open' : '') }>
                            {intl.get("MapContainer.finish_button")}
                        </Button>
                    </Link>*/}
                    {this.props.appStore.elementStore.elements && this.props.appStore.elementStore.elements.length > 0 &&
                    <div onClick={this.saveMapData}>
                        <div aria-label="Finished button" className={'finishedButton ' + (this.props.appStore.drawer.open ? 'drawer-open' : '')}>
                            {intl.get("MapContainer.finish_button")}
                        </div>
                    </div>}
                    {console.log('Elems count: ' + this.props.appStore.elementStore.elements.length)}
                </div>}


                {this.props.appStore.drawer.open &&
                <DrawerContainer/>
                }
            </div>
        );
    }
}

export default BottomContainerMobile;


// WEBPACK FOOTER //
// ./src/scenes/MapContainer/components/BottomContainerMobile/index.js